import { TypeAccessConsentModalFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import AccessConsentModal from './AccessConsentModal'

const ContentfulAccessConsentModal = withContentful<TypeAccessConsentModalFields>(AccessConsentModal, {
  heading: (props) => props.fields.heading,
  bodyContent: (props) => {
    return <BlockRenderer block={props.fields.bodyContent} />
  },
  disclaimerText: (props) => {
    return props.fields.disclaimerText ? <BlockRenderer block={props.fields.disclaimerText} /> : null
  },
  agreeButtonLabel: (props) => props.fields.agreeButtonLabel,
  redirectUrl: (props) => props.fields.redirectUrl,
})

export default ContentfulAccessConsentModal
